const menuData = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/about" },

  // DGFT
  {
    name: "DGFT  Services",
    path: "/dgft",
    children: [
      { name: "Importer Exporter Code (IEC)", path: "/dgft/iec" },
       { name: "RCMC", path: "/dgft/rcmc" },

      
        { name: "Export Promotion Capital Goods (EPCG)", path: "/dgft/epcg" },

      {
        name: "Restricted Authorization",
        children: [
          { name: "Restricted Authorization For Import", path: "/dgft/restricted-import" },
          { name: "Restricted Authorization For Export", path: "/dgft/restricted-export" },
        ],
      },

      { name: "SCOMET Authorisation", path: "/dgft/scomet" },

      {
        name: "Status House / RoDTEP / MEIS / SEIS",
        children: [
          { name: "Star Export House Certificate", path: "/dgft/status-house" },
          { name: "RoDTEP", path: "/dgft/rodtep" },
          { name: "MEIS", path: "/dgft/meis" },
          { name: "SEIS", path: "/dgft/seis" },
        ],
      },

      {
        name: "Advance / DFIA Authorisation",
        children: [
          { name: "Advance Authorisation (AA)", path: "/dgft/advance" },
          { name: "Duty-Free Import Authorisation (DFIA)", path: "/dgft/dfia" },
        ],
      },

          { name: "Deemed Exports", path: "/dgft/exim" },
      
      {
        name: "Dgft Miscellaneous Services",
        children: [
          { name: "Industrial Entrepreneur Memorandum (IEM)", path: "/dgft/iem" },
          // { name: "RCMC", path: "/dgft/rcmc" },
          { name: "DGFT Digital Signature (E-Token)", path: "/dgft/token" },
          { name: "Transport And Marketing Assistance (TMA)", path: "/dgft/tma" },
          // { name: "Steel Import Monitoring System", path: "/dgft/sims" },
          // { name: "Coal Import Monitoring System", path: "/dgft/cims" },
          // { name: "Copper/Aluminium Import Monitoring", path: "/dgft/caims" },
          // { name: "Chip Import Monitoring System", path: "/dgft/chip" },
          // { name: "Certificate Of Origin", path: "/dgft/coo" },
        ],
      },

      { name: "Authorized Economic Operator Scheme From Customs", path: "/dgft/aeo" },
     
      // { name: "DGFT Services Intro", path: "/dgft/intro" },
    ],
  },

  // INDUSTRIAL SUBSIDIES
  {
    name: "Industrial Subsidies",
    path: "/industrial-subsidies",
    children: [
    
      {
        name: "NABARD",
        children: [
          { name: "AMI Scheme", path: "/subsidy/ami" },
          // { name: "Poultry Scheme", path: "/subsidy/poultry" },
        ],
      },
       { name: "AIF - Interest Subvention", path: "/subsidy/aif" },

      {
        name: "MOFPI - Pradhan Mantri Kisan SAMPADA Yojana",
        children: [
          { name: "Mega Food Park", path: "/subsidy/mega-food-park" },
          { name: "CEFPPC", path: "/subsidy/cefppc" },
          { name: "Agro Processing Cluster", path: "/subsidy/apc" },
          { name: "Cold Chain", path: "/subsidy/cold-chain" },
          { name: "Operation Greens", path: "/subsidy/operation-greens" },
          { name: "CBFL", path: "/subsidy/cbfl" },
          { name: "Food Testing Laboratories", path: "/subsidy/ftl" },
        ],
      },

      {
        name: "National Horticulture Board / National Horticulture Mission",
        children: [
          { name: "Cold Storage Subsidy", path: "/subsidy/cold-storage" },
          { name: "Open Field", path: "/subsidy/open-field" },
          { name: "Protected Cover", path: "/subsidy/protected-cover" },
          { name: "Integrated Post Harvest", path: "/subsidy/post-harvest" },
          { name: "Cluster Development", path: "/subsidy/cluster" },
        ],
      },

      // { name: "Telangana State Food Processing Policy", path: "/subsidy/ts-policy" },
     
      { name: "MSME - CLCSS", path: "/subsidy/clcss" },

            // { name: "NSC - Seed Processing Units", path: "/subsidy/nsc" },
      { name: "APEDA - Financial Assistance", path: "/subsidy/apeda" },
      // { name: "SFAC - VCA Interest Free Loan", path: "/subsidy/sfac" },
    ],
  },

  // { name: "MOOWR Scheme", path: "/moowr" },

{ name: "Subsidy Calculator", path: "/subsidycal" },

  // {
  //   name: "Notifications",
  //   children: [
  //     { name: "DGFT Notifications", path: "/notifications/dgft" },
  //     { name: "Industrial Subsidy Notifications", path: "/notifications/subsidy" },
  //   ],
  // },

  // { name: "Blog", path: "/blog" },
  { name: "Contact Us", path: "/contact" },
];

export default menuData;
